pageId = 'members-reports-index'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  $('#link-change-date').on 'click', tower.changeReportDate
  tower.workStatus()
